<template>
  <div class="col-12 col-xl-12" v-can="'chapters.display'">
    <div class="card mb-3 mb-xxl-5 me-xxl-4" style="margin-top: 4rem; overflow: visible">
      <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height: 60px">
        <div class="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
          <h6 class="text-white text-capitalize ps-3 pe-3" style="font-size: 1rem">
            {{ $t('chapters.tableTitle') }}
          </h6>
        </div>
      </div>

      <div class="card-body px-0 pb-2 pe-xl-3">
        <div class="table-responsive p-1 p-xl-4">
          <LoadingSpinner
            v-if="loading && chapters.length === 0"
            :message="$t('chapters.loading')"
            class="py-5"
          />

          <template v-else>
            <div class="d-block d-xl-none">
              <div v-if="!loading && chapters.length === 0" class="text-center py-3 text-muted">
                <i class="fas fa-book-open fa-2x mb-2"></i>
                <p>{{ $t('chapters.noChapters') }}</p>
              </div>

              <div
                v-for="chapter in chapters"
                :key="'mobile-' + chapter.id"
                class="card mb-3 mx-2"
                style="cursor: pointer;"
              >
                <div class="card-body py-2">
                  <div class="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 class="mb-0 text-sm">{{ chapter.name }}</h6>
                    </div>
                  </div>

                  <div class="d-flex justify-content-end mt-2">
                    <router-link
                      :to="{ name: 'chapters.edit', params: { id: chapter.id } }"
                      class="btn btn-link text-secondary p-0 mx-1"
                      :title="$t('chapters.edit')"
                      v-can="'chapters.update'"
                    >
                      <i class="fas fa-edit fa-xs"></i>
                    </router-link>

                    <button
                      type="button"
                      @click.stop.prevent="emitDeleteChapter(chapter)"
                      class="btn btn-link text-danger p-0 mx-1"
                      :title="$t('chapters.delete')"
                      v-can="'chapters.delete'"
                    >
                      <i class="fas fa-trash fa-xs"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <table class="table align-items-center mb-0 d-none d-xl-table">
              <thead>
                <tr>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7">
                    {{ $t('chapters.name') }}
                  </th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-center pe-4">
                    {{ $t('chapters.actions') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!loading && chapters.length === 0">
                  <td colspan="2" class="text-center py-4 text-muted">
                    <i class="fas fa-book-open fa-2x mb-2"></i>
                    <p>{{ $t('chapters.noChapters') }}</p>
                  </td>
                </tr>

                <tr v-for="chapter in chapters" :key="chapter.id">
                  <td>
                    <div class="d-flex px-3 py-1">
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-md">{{ chapter.name }}</h6>
                      </div>
                    </div>
                  </td>

                  <td class="align-middle text-center pe-4">
                    <div class="d-inline-flex">
                      <router-link
                        :to="{ name: 'chapters.edit', params: { id: chapter.id } }"
                        class="btn btn-link text-secondary p-1 mx-1"
                        :title="$t('chapters.edit')"
                        v-can="'chapters.update'"
                      >
                        <i class="fas fa-edit fa-sm"></i>
                      </router-link>

                      <button
                        type="button"
                        @click.stop.prevent="emitDeleteChapter(chapter)"
                        class="btn btn-link text-danger p-1 mx-1"
                        :title="$t('chapters.delete')"
                        v-can="'chapters.delete'"
                      >
                        <i class="fas fa-trash fa-sm"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import LoadingSpinner from "@/components/common/LoadingSpinner.vue";

defineProps({
  chapters: {
    type: Array,
    required: true,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["delete-chapter"]);

const emitDeleteChapter = (chapter) => {
  emit("delete-chapter", chapter);
};
</script>